module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.8749","quantity":0.01875},{"color":"#9dc4b5","label":" 1.8749- 2.10078","quantity":0.02101},{"color":"#e6efc3","label":" 2.10078- 2.68664","quantity":0.02687},{"color":"#ffe89e","label":" 2.68664- 3.55798","quantity":0.03558},{"color":"#f5af7f","label":" 3.55798- 4.9273","quantity":0.04927},{"color":"#ed6d32","label":" 4.9273- 14.67897","quantity":0.14679}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_80_return_20.json
// module id = x3jX
// module chunks = 171